import React, { Fragment, useState, useEffect, useContext } from 'react';
import propTypes from 'prop-types';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import Questions from 'components/installation/dynamicForm/questions';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from '../../../../contexts/baseUrl/baseUrl';

const PreCamp = ({
  getPreCampQues,
  postPreCampQues,
  quesList,
  documentUploadUrl,
  match,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [checkListData, setCheckListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState(null);
  const [siteId, setSiteId] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [allQuestions, setallQuestions] = useState([]);
  const [isFiled, setIsFiled] = useState(false);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setId(match.params.id);
    setSiteId(match.params.siteId);
  }, [match]);

  const handleIsSuccess = () => {
    setIsSuccess(false);
    history.goBack();
  };

  const handleSubmit = async () => {
    const data = {
      camp_id: id,
      site_id: siteId,
      checklist_answers: allQuestions,
    };
    if (allQuestions.length > 0) {
      setIsFiled(true);
      setIsValid(false);
      setIsLoading(true);
      await postPreCampQues(data);
      setIsSuccess(true);
      setIsLoading(false);
    } else {
      setIsFiled(false);
      setIsValid(true);
    }
  };

  useEffect(() => {
    if (quesList !== null && quesList) {
      setCheckListData(quesList);
    } else setCheckListData([]);
  }, [quesList]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getPreCampQues();
      setIsLoading(false);
    })();
  }, [getPreCampQues]);

  const headerBtns = () => {
    return (
      <Fragment>
        {quesList !== null && quesList && (
          <Button onClick={handleSubmit} className="btn btn-primary">
            {localization.submitDtl}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        )}
      </Fragment>
    );
  };

  const successIconBox = () => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.addPreCampAnsSuccess}</h5>
        <Button onClick={handleIsSuccess} className="btn btn-primary">
          {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const handleQuestion = (val) => {
    if (val !== undefined && val !== null) {
      if (allQuestions && allQuestions.length === 0) {
        allQuestions.push(val);
        setallQuestions([...allQuestions]);
      } else {
        const isThere = allQuestions.findIndex((obj) => obj.id === val.id);
        if (isThere === -1) {
          allQuestions.push(val);
          setallQuestions([...allQuestions]);
        } else {
          allQuestions.splice(isThere, 1);
          allQuestions.push(val);
          setallQuestions([...allQuestions]);
        }
      }
    }
  };

  return (
    <Fragment>
      <Layout
        title={localization.preCamp}
        isLoading={isLoading}
        isGoback
        Buttons={headerBtns}
        className={isValid && 'requiredFileds'}
        linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp/${match.params.siteId}`}
      >
        {checkListData.length > 0 && (
          <Questions
            data={checkListData}
            handleValue={handleQuestion}
            documentUploadUrl={documentUploadUrl}
            className={isValid && 'requiredFileds'}
          />
        )}
      </Layout>
      <ModalPop
        title={localization.success}
        show={isSuccess}
        handleModalHide={handleIsSuccess}
      >
        {successIconBox()}
      </ModalPop>
    </Fragment>
  );
};

PreCamp.propTypes = {
  fetchComplainList: propTypes.func,
};

export default PreCamp;
